export default {
    "page": {
      "account_exists": {
        "text": "Es sieht so aus, als hätten Sie bereits ein Konto.",
        "button": "Weiter zu meinem Konto"
      },
      "existing_page": {
        "title": "Wählen Sie ein bestehendes Unternehmen.",
        "button": "Weiter mit dieser Firma"
      }
    },
    "success": "Sie sind jetzt registriert!"
};